import React from 'react';
import EstoqueRR from './EstoqueRR';
import EstoqueSubmateriais from './EstoqueSubmateriais';
import Filter from '../../../Auxiliar/Filter';


const SelecionarJsEstoque = () => {
    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        estoqueRR: { value: true, label: 'Estoque de Matérias Primas', checked: true },
        estoqueSubmaterial: { value: false, label: 'Estoque de Sub-Materiais', checked: false },
    })

    return (
        <div className="card">
            <div className="card-body" id="card">
                <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Estoque</h4>
                <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os materiais e sub-materiais do sistema</p>
                </div>
                <div className="row">
                    {options.estoqueRR.value &&
                        <EstoqueRR dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                    {options.estoqueSubmaterial.value &&
                        <EstoqueSubmateriais dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsEstoque


